import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import * as VueGoogleMaps from "vue2-google-maps";
import MultiLanguage from 'vue-multilanguage';
import language from '../lang/language'
import Carousel3d from 'vue-carousel-3d';
import router from './router'

Vue.use(Carousel3d);
Vue.use(Vuetify);
Vue.use(MultiLanguage, language);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAtQOTQlF6ldRqAPgqXDT6hBd1o49Xc3KE",
    // libraries: "places" // necessary for places input
  }
});

new Vue({
  components: { App },
  router,
  template: '<App/>', 
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js